<mat-dialog-content>
    <div class="hypo-dialog-header">
        <div class="hypo-dialog-title">Změnilo se něco od {{ mortgage.lastContactedAt | date }}?</div>
    </div>

    <div class="hypo-dialog-content">
        <div class="confirm-message">
            Řešení hypotéky je pozastaveno, můžete v něm však hned pokračovat. Chcete si nejprve zkontrolovat, že údaje,
            které jste zadávali při řešení, jsou stále aktuální?
        </div>

        <div class="hypo-dialog-footer mb-4 flex flex-row items-center justify-around">
            <button
                (click)="dialogRef.close('check')"
                class="btn btn-sm orange"
                mat-button
                [attr.data-testid]="'check-data-dialog-button-check'"
                type="button">
                Zkontroluji si údaje
            </button>
            <button
                (click)="dialogRef.close('dontCheck')"
                class="btn btn-sm orange"
                mat-raised-button
                [attr.data-testid]="'check-data-dialog-button-skip'"
                type="button">
                Přeskočit kontrolu
            </button>
        </div>
    </div>
</mat-dialog-content>
